<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        :width="size"
        :height="size"
        viewBox="0 0 24 24"
        :aria-labelledby="name"
        role="presentation"
        class="inline-block align-center"
    >
        <title :id="name" lang="en">{{ titleString }}</title>
        <g :fill="fillColor" :stroke="strokeColor">
            <component :is="iconName" />
        </g>
    </svg>
</template>

<script lang="ts">
import { defineComponent, computed } from 'vue'
import IconLogout from '@/common/components/ui/icons/IconLogout.vue'
import IconMenu from '@/common/components/ui/icons/IconMenu.vue'
import IconMoon from '@/common/components/ui/icons/IconMoon.vue'
import IconSeparator from '@/common/components/ui/icons/IconSeparator.vue'
import IconSettings from '@/common/components/ui/icons/IconSettings.vue'
import IconSun from '@/common/components/ui/icons/IconSun.vue'
import IconPatreon from '@/common/components/ui/icons/IconPatreon.vue'

export default defineComponent({
    name: 'IconBase',
    components: {
        IconLogout,
        IconMenu,
        IconMoon,
        IconSeparator,
        IconSettings,
        IconSun,
        IconPatreon,
    },
    props: {
        name: {
            type: String,
            required: true,
        },
        title: {
            type: String,
        },
        size: {
            type: [Number, String],
            default: 24,
        },
        fillColor: {
            type: String,
            default: 'currentColor',
        },
        strokeColor: {
            type: String,
            default: 'rgba(255,255,255,0)',
        },
    },
    setup(props) {
        const iconName = computed(() => {
            return props.name ? `icon-${props.name}` : ''
        })

        const titleString = props.title ? props.title : ''

        return {
            iconName,
            titleString,
        }
    },
})
</script>
